import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {ApiResponseSchedule} from "features/model/types/groups/schedule/scheduleSchema";

interface IFetchSchedule {
    month: string,
    year: string,
    time_zone: string | null,
    new: number,
    finished: number,
    has_problem: number,
    groupId:string | undefined,
}

export const fetchSchedule = createAsyncThunk(
    "lessons/fetchSchedule",
    async (scheduleData: IFetchSchedule, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get<ApiResponseSchedule>(
                `/api/lessons/schedule`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: scheduleData,
                }
            );

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
